var exports = {
  "vK": "banner__eGcHu6",
  "UX": "upsell__hgquLT",
  "HX": "basic__WHh74a",
  "lm": "notice__WyXlda",
  "z3": "error__FO3E3P",
  "X4": "removeAccessButton__J8oJxy",
};

module.exports = exports;
